import React from "react";
import styled from "styled-components";



import PrimaryFilledCircle from "../../assets/img/icons/filled_circle_primary.svg";
import GreyCircle from "../../assets/img/icons/grey-circle.svg";
import { CommonText } from "../../styledComponents/common";
import ButtonHelpTooltip from "../Tooltip/ButtonHelpTooltip";

export const CircleIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const TabContainer = styled.div`
  display: flex;
  border-radius: ${props => (props.selected ? "32px" : "8px")};
  height: ${props => props.height || "40px"};
  padding: ${props => props.padding || "8px 12px"};
  gap: 8px;
  font-weight: 700;
  font-size: 14px;
  align-items: center;
  cursor: pointer;
  border: 1px solid
    ${props =>
      props.error
        ? props.theme.colors.main.error
        : props.selected
        ? props.theme.colors.main.primary
        : props.theme.colors.border.secondaryLight};
  background-color: ${props =>
    ((!props.showIcon || props.filled) && props.selected) ? "#2266EF" : "white"};
  max-width: fit-content;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${props =>
      props.selected
        ? props.theme.colors.main.primary
        : props.theme.colors.main.primary};
    opacity: ${props => (props.selected ? "1" : "0.8")};
    background-color: ${props =>
      ((!props.showIcon || props.filled) && props.selected) ? "#2266EF" : "white"};
  }
`;

const RoundTab = ({
  text,
  selected = false,
  onClick,
  showIcon = true,
  customIcon = null,
  error = false,
  height = "40px",
  padding,
  filled=false,
  tooltipEnabled = false,
  tooltipText = "",
}) => {
  const getIcon = () => {
    if (customIcon) return customIcon;
    return selected ? PrimaryFilledCircle : GreyCircle;
  };

  const renderIcon = () => {
    const icon = getIcon();
    
    // Check if icon is a React component or element
    if (React.isValidElement(icon)) {
      return <IconWrapper>{icon}</IconWrapper>;
    }
    
    // Otherwise, treat it as an image source
    return (
      <CircleIcon
        src={icon}
        alt={`${selected ? "Selected" : "Unselected"} Icon`}
      />
    );
  };

  return (
    <ButtonHelpTooltip enabled={tooltipEnabled} text={tooltipText}>
      <TabContainer
        selected={selected}
        error={error}
        showIcon={showIcon}
        onClick={onClick}
        height={height}
        padding={padding}
        filled={filled}
      >
        {showIcon && renderIcon()}
        <CommonText
          color={
            ((!showIcon || filled) && selected) ? "#FFFFFF" : selected ? "#2266EF" : undefined
          }
          fontWeight={selected ? "600" : "400"}
          fontSize="14px"
          margin="0"
          mobileFontSize="12px"
        >
          {text}
        </CommonText>

      </TabContainer>
    </ButtonHelpTooltip>
  );
};

export default RoundTab;